import { default as videojs } from 'video.js';
import { LogoOptions } from '../../../models';
import { ComponentBase } from './component-base';
import Component = videojs.Component;

export type LogoComponentOptions = videojs.ComponentOptions & LogoOptions;

export class Logo extends ComponentBase {

    static readonly ComponentName: string = 'Logo';

    image: string;
    shouldHide: boolean;
    position: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right' | 'control-bar' = 'top-right';

    constructor(player?: videojs.Player, options?: LogoComponentOptions, readyCallback?: Component.ReadyCallback) {
        super(player, options, readyCallback);

        this.position = options.position || this.position;
        this.shouldHide = options.hide || false;
        this.image = options.file || '';
        this.addClass(this.position);
        if (this.shouldHide) {
            this.addClass('vjs-planet-logo-hide');
        }

        this.update();
    }

    name(): string {
        return Logo.ComponentName;
    }

    update(): void {
        this.el().setAttribute('src', this.image);
    }

    createEl(): Element {
        return super.createEl('img', {
            className: 'vjs-planet-logo-image',
        }, {src: this.image || ''});
    }
}
